import React from 'react'

type Props = {
  className?: string
}

const News = ({ className }: Props) => (
  <svg width="48" height="49" viewBox="0 0 48 49" fill="none" className={className}>
    <path d="M41 12.2026H39V14.2026H41V12.2026Z" fill="#2979FF" />
    <path
      d="M40.989 48.2026C40.831 48.2026 40.671 48.1946 40.512 48.1796C39.2581 48.0269 38.1046 47.4172 37.2722 46.4672C36.4397 45.5172 35.9868 44.2937 36 43.0306V6.20264H38V43.0306C37.9833 43.7968 38.2493 44.5424 38.7473 45.1249C39.2454 45.7074 39.9405 46.0861 40.7 46.1886C41.1172 46.2306 41.5386 46.1846 41.937 46.0536C42.3354 45.9226 42.7019 45.7095 43.0128 45.4282C43.3238 45.1468 43.5723 44.8034 43.7423 44.4201C43.9123 44.0367 44.0001 43.622 44 43.2026V15.2026C44 14.9374 43.8946 14.6831 43.7071 14.4955C43.5195 14.308 43.2652 14.2026 43 14.2026H42V40.2026H43V42.2026H41C40.7348 42.2026 40.4804 42.0973 40.2929 41.9097C40.1053 41.7222 40 41.4679 40 41.2026V13.2026C40 12.9374 40.1053 12.6831 40.2929 12.4955C40.4804 12.308 40.7348 12.2026 41 12.2026H43C43.7956 12.2026 44.5587 12.5187 45.1213 13.0813C45.6839 13.6439 46 14.407 46 15.2026V43.2026C46 43.8602 45.8703 44.5113 45.6183 45.1186C45.3664 45.7259 44.9971 46.2776 44.5316 46.7421C44.0662 47.2065 43.5137 47.5746 42.9058 47.8252C42.2979 48.0758 41.6465 48.2041 40.989 48.2026V48.2026Z"
      fill="#2979FF"
    />
    <path
      d="M4 34.2026H2V1.20264C2 0.93742 2.10536 0.683066 2.29289 0.49553C2.48043 0.307994 2.73478 0.202637 3 0.202637L37 0.202637C37.2652 0.202637 37.5196 0.307994 37.7071 0.49553C37.8946 0.683066 38 0.93742 38 1.20264V4.20264H36V2.20264H4V34.2026Z"
      fill="#2979FF"
    />
    <path d="M4 36.2026H2V38.2026H4V36.2026Z" fill="#2979FF" />
    <path
      d="M41 48.2026H7C5.6744 48.201 4.40356 47.6738 3.46622 46.7364C2.52888 45.7991 2.00159 44.5282 2 43.2026V40.2026H4V43.2026C4 43.9983 4.31607 44.7613 4.87868 45.324C5.44129 45.8866 6.20435 46.2026 7 46.2026H41V48.2026Z"
      fill="#2979FF"
    />
    <path
      d="M33 14.2026H7C6.73478 14.2026 6.48043 14.0973 6.29289 13.9097C6.10536 13.7222 6 13.4679 6 13.2026V5.20264C6 4.93742 6.10536 4.68307 6.29289 4.49553C6.48043 4.30799 6.73478 4.20264 7 4.20264H33C33.2652 4.20264 33.5196 4.30799 33.7071 4.49553C33.8946 4.68307 34 4.93742 34 5.20264V13.2026C34 13.4679 33.8946 13.7222 33.7071 13.9097C33.5196 14.0973 33.2652 14.2026 33 14.2026ZM8 12.2026H32V6.20264H8V12.2026Z"
      fill="#2979FF"
    />
    <path d="M12 8.20264H10V10.2026H12V8.20264Z" fill="#2979FF" />
    <path d="M30 8.20264H14V10.2026H30V8.20264Z" fill="#2979FF" />
    <path
      d="M18 30.2026H7C6.73478 30.2026 6.48043 30.0973 6.29289 29.9097C6.10536 29.7222 6 29.4679 6 29.2026V17.2026C6 16.9374 6.10536 16.6831 6.29289 16.4955C6.48043 16.308 6.73478 16.2026 7 16.2026H18C18.2652 16.2026 18.5196 16.308 18.7071 16.4955C18.8946 16.6831 19 16.9374 19 17.2026V29.2026C19 29.4679 18.8946 29.7222 18.7071 29.9097C18.5196 30.0973 18.2652 30.2026 18 30.2026ZM8 28.2026H17V18.2026H8V28.2026Z"
      fill="#2979FF"
    />
    <path
      d="M33 42.2026H22C21.7348 42.2026 21.4804 42.0973 21.2929 41.9097C21.1054 41.7222 21 41.4679 21 41.2026V29.2026C21 28.9374 21.1054 28.6831 21.2929 28.4955C21.4804 28.308 21.7348 28.2026 22 28.2026H33C33.2652 28.2026 33.5196 28.308 33.7071 28.4955C33.8946 28.6831 34 28.9374 34 29.2026V41.2026C34 41.4679 33.8946 41.7222 33.7071 41.9097C33.5196 42.0973 33.2652 42.2026 33 42.2026ZM23 40.2026H32V30.2026H23V40.2026Z"
      fill="#2979FF"
    />
    <path d="M8 32.2026H6V34.2026H8V32.2026Z" fill="#2979FF" />
    <path d="M19 32.2026H10V34.2026H19V32.2026Z" fill="#2979FF" />
    <path d="M23 16.2026H21V18.2026H23V16.2026Z" fill="#2979FF" />
    <path d="M34 16.2026H25V18.2026H34V16.2026Z" fill="#2979FF" />
    <path d="M34 20.2026H21V22.2026H34V20.2026Z" fill="#2979FF" />
    <path d="M19 36.2026H6V38.2026H19V36.2026Z" fill="#2979FF" />
    <path d="M19 40.2026H6V42.2026H19V40.2026Z" fill="#2979FF" />
    <path d="M34 24.2026H21V26.2026H34V24.2026Z" fill="#2979FF" />
    <path
      d="M29.293 37.9097L26 34.6167L22.707 37.9097L21.293 36.4957L25.293 32.4957C25.4805 32.3082 25.7348 32.2029 26 32.2029C26.2651 32.2029 26.5194 32.3082 26.707 32.4957L30.707 36.4957L29.293 37.9097Z"
      fill="#2979FF"
    />
    <path
      d="M32.293 36.9097L30 34.6167L28.707 35.9097L27.293 34.4957L29.293 32.4957C29.4805 32.3082 29.7348 32.2029 30 32.2029C30.2651 32.2029 30.5194 32.3082 30.707 32.4957L33.707 35.4957L32.293 36.9097Z"
      fill="#2979FF"
    />
    <path
      d="M10 26.2027H7V24.2027H9.586L13.293 20.4957C13.4805 20.3082 13.7348 20.2029 14 20.2029C14.2652 20.2029 14.5195 20.3082 14.707 20.4957L18.707 24.4957L17.293 25.9097L14 22.6167L10.707 25.9097C10.5195 26.0972 10.2652 26.2026 10 26.2027Z"
      fill="#2979FF"
    />
  </svg>
)

export default News
